export default "assets/images/logo-9faaf674.png";